<template>
  <div class="basket">
    <div class="row order-header">
      <div class="col-12">
        Twoje zamówienie
      </div>
    </div>
    <div v-for="b in basket.basket.baskets" class="order-header-basket order-group">
      <div class="row order-header-address">
        <div class="col-12">Adres dostawy:
          <div v-if="b.address" class="basket-group-delivery">{{ b.address.city }}, {{ b.address.street }}</div>
        </div>
      </div>
      <div class="table-responsive">
        <table class="table order-header-cols">
          <thead>
          <tr>
            <th class="col-1" scope="col">Zdjęcie</th>
            <th scope="col">Nazwa</th>
            <th scope="col">Mpk</th>
            <th scope="col">Ilość</th>
            <th scope="col">Cena netto</th>
            <th scope="col">VAT</th>
            <th scope="col">Cena brutto</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="position in b.positions" class="order-position">
            <td><img :src="position.photo_url" class="img-fluid order-img"/></td>
            <td><span class="order-name-name">{{position.name}}</span>
              <span class="order-name-desc">{{position.description}}</span>
            </td>
            <td>-</td>
            <td>{{position.cart_quantity}}</td>
            <td>{{formatPrice(position.price_net * position.cart_quantity)}} {{currency().currency.symbol}}</td>
            <td>{{formatPrice(position.price_tax * position.cart_quantity)}} {{currency().currency.symbol}}</td>
            <td>{{formatPrice(position.price_gross * position.cart_quantity)}} {{currency().currency.symbol}}</td>
          </tr>

          <tr class="basket-footer">
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>{{formatPrice(b.price_net)}} {{currency().currency.symbol}}</td>
            <td>{{formatPrice(b.price_tax)}} {{currency().currency.symbol}}</td>
            <td>{{formatPrice(b.price_gross)}} {{currency().currency.symbol}}</td>
          </tr>

          </tbody>
        </table>
      </div>
      <div class="row order-header">
        <div class="col-12">
          <button type="button" class="btn btn-success pull-right" @click="createOrder()">Złóż zamówienie</button>
        </div>
      </div>

    </div>
  </div>
</template>


<script>

  import DeleteIcon from "vue-material-design-icons/delete.vue"
  import SubIcon from "vue-material-design-icons/minus.vue"
  import PlusIcon from "vue-material-design-icons/plus.vue"
  import {mapState, mapGetters} from 'vuex';
  import MinusIcon from "vue-material-design-icons/minus.vue";


  export default {
    computed: {
      ...mapState({
        basket: state => state.basket,
        order: state => state.order
      }),
      ...mapGetters({
        currency: 'company/selectedCurrency'
      })
    },

    methods: {
      formatPrice(value) {
        let currValue = value * this.currency().value;

        let val = (currValue / 1).toFixed(2).replace('.', ',');
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },

      async createOrder() {
        await this.$store.dispatch('order/create');
        this.$router.replace({name: 'orders'});

      }


    },

    beforeMount() {
      if (!this.$store.state.user.authorizedUser) {
        this.$router.replace({name: 'mainPage'});
      }

      this.$store.dispatch('basket/data');


    }
  }
</script>



// WEBPACK FOOTER //
// node_modules/redbay-b2b-order/src/CreateOrderPage.vue